// src/features/notificationService.js
class NotificationService {
  constructor() {
    this.eventSource = null;
    this.callbacks = [];
    this.connected = false;
  }

  getBaseUrl() {
    if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
      return 'https://api-easypointme.bakeli.tech/api';
    }
    return 'http://127.0.0.1:8000/api/';
  }

  connect() {
    try {
      this.eventSource = new EventSource(
        `${this.getBaseUrl()}notifications/stream`,
        { withCredentials: true }
      );

      this.eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.notifyCallbacks(data);
      };

      this.eventSource.onerror = (error) => {
        console.error('SSE Error:', error);
        this.disconnect();
        // Tentative de reconnexion après 5 secondes
        setTimeout(() => this.connect(), 5000);
      };

      this.connected = true;
    } catch (error) {
      console.error('SSE Connection Error:', error);
    }
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
    this.connected = false;
  }

  subscribe(callback) {
    this.callbacks.push(callback);
    return () => {
      this.callbacks = this.callbacks.filter(cb => cb !== callback);
    };
  }

  notifyCallbacks(data) {
    this.callbacks.forEach(callback => callback(data));
  }

  playNotificationSound() {
    const audio = new Audio('/notification-sound.mp3');
    audio.play().catch(() => {});
  }
}

export const notificationService = new NotificationService();